import * as React from "react";
const SvgIcon24 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 21" {...props}><defs><clipPath id="icon_24_svg__clip-path"><path style={{
        fill: "none"
      }} d="M2 1h21v21H2z" /></clipPath><style>{".icon_24_svg__cls-4{fill:none;stroke:var(--text-color-1,#fff);stroke-linecap:round;stroke-width:1.15px}"}</style></defs><g transform="translate(-2 -1)" style={{
    isolation: "isolate",
    clipPath: "url(#icon_24_svg__clip-path)"
  }}><path d="M12.962 0a.908.908 0 0 1 .783.448l4.008 6.813a.908.908 0 0 1 0 .921L13.745 15a.908.908 0 0 1-.783.448H4.916A.908.908 0 0 1 4.133 15L.125 8.182a.908.908 0 0 1 0-.921L4.133.448A.908.908 0 0 1 4.916 0Z" transform="rotate(30 2.638 16.541)" style={{
      strokeWidth: "1.3px",
      stroke: "var(--text-color-1,#fff)",
      fill: "none"
    }} /><path className="icon_24_svg__cls-4" d="M12.505 16.169v-4.092M12.504 12.077l3.544-2.046M12.505 12.077l-3.544-2.046" /></g></svg>;
export default SvgIcon24;